{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2016 - 2025                               }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCCustomComponent;

//{$DEFINE RTLONLY}

{$IFNDEF RTLONLY}
{$I WEBLib.TMSFNCDefines.inc}
{$IFDEF CMNLIB}
{$DEFINE CMNWEBLIB}
{$ENDIF}
{$IFDEF WEBLIB}
{$DEFINE CMNWEBLIB}
{$ENDIF}
{$IFDEF FNCLIB}
{$DEFINE USETRIAL}
{$ELSE}
{$IFDEF FMXLIB}
{$DEFINE USETRIAL}
{$ENDIF}
{$ENDIF}
{$ELSE}
//RTL ONLY
{$IFDEF IOS}
{$DEFINE FMXMOBILE}
{$IFNDEF VER340}
{$IFNDEF VER350}
{$IFNDEF VER360}
{$IFNDEF VER370}
{$DEFINE ZEROSTRINGINDEX}
{$ENDIF}
{$ENDIF}
{$ENDIF}
{$ENDIF}
{$ENDIF}
{$IFDEF ANDROID}
{$DEFINE FMXMOBILE}
{$IFNDEF VER340}
{$IFNDEF VER350}
{$IFNDEF VER360}
{$IFNDEF VER370}
{$DEFINE ZEROSTRINGINDEX}
{$ENDIF}
{$ENDIF}
{$ENDIF}
{$ENDIF}
{$ENDIF}
{$DEFINE FNCLIB}
{$DEFINE USETRIAL}

{$IFDEF FRAMEWORK_VCL}
{$DEFINE VCLLIB}
{$ENDIF}
{$IFDEF FRAMEWORK_FMX}
{$DEFINE FMXLIB}
{$ENDIF}

{$IFNDEF FRAMEWORK_FMX}
{$IFNDEF FRAMEWORK_VCL}
{$DEFINE FMXLIB}
{$ENDIF}
{$ENDIF}

{$ENDIF}

interface

uses
  {$IFDEF RTLONLY}
  {$IFDEF FREEWARE}
  {$IFDEF FMXLIB}
  {$IFDEF MSWINDOWS}
  FMX.Platform.Win,
  {$ENDIF}
  {$ENDIF}
  {$ENDIF}
  {$ENDIF}
  {$IFDEF MSWINDOWS}
  {%H-}Windows,
  {$ENDIF}
  Classes
  ,WEBLib.TMSFNCTypes
  ,WEBLib.TMSFNCPersistence
  {$IFNDEF RTLONLY}
  ,WEBLib.Controls
  {$ENDIF}
  {$IFNDEF FNCLIB}
  {$IFDEF VCLLIB}
  {$IFDEF FREEWARE}
  ,TMSTrial
  {$ENDIF}
  {$ENDIF}
  {$ENDIF}
  ,TypInfo;

type
  TTMSFNCCustomComponentCanSavePropertyEvent = procedure(Sender: TObject; AObject: TObject; APropertyName: string; APropertyType: TTypeKind; var ACanSave: Boolean) of object;
  TTMSFNCCustomComponentCanLoadPropertyEvent = procedure(Sender: TObject; AObject: TObject; APropertyName: string; APropertyType: TTypeKind; var ACanLoad: Boolean) of object;

  {$IFNDEF RTLONLY}
  {$IFDEF CMNWEBLIB}
  TTMSFNCNameLabel = class(TCustomControl)
  {$ELSE}
  TTMSFNCNameLabel = class(TControl)
  {$ENDIF}
  private
    function GetText: string;
  protected
    procedure Paint; override;
  public
    {$IFDEF FMXLIB}
    procedure SetBounds(X, Y, AWidth, AHeight: Single); override;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    procedure SetBounds(X, Y, {%H-}AWidth, {%H-}AHeight: Integer); override;
    {$ENDIF}

    property Text: string read GetText;
  end;
  {$ENDIF}

  {$IFNDEF RTLONLY}
  {$IFDEF CMNWEBLIB}
  TTMSFNCCustomComponent = class(TCustomControl, ITMSFNCProductInfo, ITMSFNCPersistence)
  private
    FStored: Boolean;
  {$ELSE}
  TTMSFNCCustomComponent = class(TControl, ITMSFNCProductInfo, ITMSFNCPersistence)
  {$ENDIF}
  {$ELSE}
  TTMSFNCCustomComponent = class(TComponent, ITMSFNCProductInfo, ITMSFNCPersistence)
  {$ENDIF}
  private
    class var FBlockPersistenceInterface: Boolean;
  private
    {$IFNDEF RTLONLY}
    FNameLabel: TTMSFNCNameLabel;
    {$ENDIF}
    FDesigntimeFormPixelsPerInch: Integer;
    FAppearancePersisting: Boolean;
    FAdaptToStyle: Boolean;
    FOnCanSaveProperty: TTMSFNCCustomComponentCanSavePropertyEvent;
    FOnCanLoadProperty: TTMSFNCCustomComponentCanLoadPropertyEvent;
  protected
    {$IFDEF WEBLIB}
    class function GetVersionNumber(AMaj, AMin, ARel, ABld: ShortInt): string;
    {$ENDIF}
    procedure DoCanSaveProperty(AObject: TObject; APropertyName: string; APropertyType: TTypeKind; var ACanSave: Boolean); virtual;
    procedure DoCanLoadProperty(AObject: TObject; APropertyName: string; APropertyType: TTypeKind; var ACanLoad: Boolean); virtual;
    function IsAppearanceProperty({%H-}AObject: TObject; {%H-}APropertyName: string; {%H-}APropertyType: TTypeKind): Boolean; virtual;
    function CanSaveProperty({%H-}AObject: TObject; {%H-}APropertyName: string; {%H-}APropertyType: TTypeKind): Boolean; virtual;
    function CanLoadProperty({%H-}AObject: TObject; {%H-}APropertyName: string; {%H-}APropertyType: TTypeKind): Boolean; virtual;
    function GetVersion: string; virtual;
    function GetDocURL: string; virtual;
    function GetTipsURL: string; virtual;
    function GetInstance: NativeUInt; virtual;
    {$IFNDEF RTLONLY}
    procedure SetDefaultGraphicColors;
    {$IFDEF VCLLIB}
    {$HINTS OFF}
    {$IF COMPILERVERSION > 30}
    procedure ChangeScale(M, D: Integer; isDpiChange: Boolean); override;
    {$ELSE}
    procedure ChangeScale(M, D: Integer); override;
    {$IFEND}
    {$HINTS ON}
    {$ENDIF}
    {$ENDIF}
    procedure ChangeDPIScale({%H-}M, {%H-}D: Integer); virtual;
    procedure SetAdaptToStyle(const Value: Boolean); virtual;
    {$IFNDEF RTLONLY}
    procedure Paint; override;
    {$ENDIF}
    procedure Loaded; override;
    procedure RealignLabel;
    procedure RegisterRuntimeClasses; virtual;
    procedure Notification(AComponent: TComponent; AOperation: TOperation); override;
    property AdaptToStyle: Boolean read FAdaptToStyle write SetAdaptToStyle default False;
  public
    constructor Create(AOwner: TComponent); override;
    procedure SetName(const Value: TComponentName); override;
    {$IFDEF FMXLIB}
    {$IFNDEF RTLONLY}
    procedure SetBounds(X, Y, AWidth, AHeight: Single); override;
    {$ENDIF}
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    {$IFNDEF RTLONLY}
    procedure SetBounds(X, Y, {%H-}AWidth, {%H-}AHeight: Integer); override;
    {$ENDIF}
    property Stored: Boolean read FStored write FStored;
    {$ENDIF}
    {$IFDEF FMXLIB}
    {$HINTS OFF}
    {$IF COMPILERVERSION = 28}
    procedure BeginUpdate; virtual;
    procedure EndUpdate; virtual;
    {$IFEND}
    {$HINTS ON}
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    {$IFDEF WEBLIB}
    procedure BeginUpdate; override;
    procedure EndUpdate; override;
    {$ENDIF}
    {$IFNDEF WEBLIB}
    procedure BeginUpdate; virtual;
    procedure EndUpdate; virtual;
    {$ENDIF}
    {$ENDIF}
    function IsDesignTime: Boolean; virtual;
    function IsLoading: Boolean; virtual;
    function IsReading: Boolean; virtual;
    function IsDesigning: Boolean; virtual;
    function IsDestroying: Boolean; virtual;
    procedure SaveSettingsToFile(AFileName: string; AAppearanceOnly: Boolean = False); virtual;
    procedure LoadSettingsFromFile(AFileName: string); virtual;
    procedure SaveSettingsToStream(AStream: TStream; AAppearanceOnly: Boolean = False); virtual;
    procedure LoadSettingsFromStream(AStream: TStream); virtual;
    class property BlockPersistenceInterface: Boolean read FBlockPersistenceInterface write FBlockPersistenceInterface;
    property DesigntimeFormPixelsPerInch: Integer read FDesigntimeFormPixelsPerInch;
  published
    {$IFNDEF RTLONLY}
    {$IFDEF FMXLIB}
    {$HINTS OFF}
    {$IF COMPILERVERSION > 27}
    property Size;
    {$IFEND}
    {$HINTS ON}
    property Position;
    {$ENDIF}
    property Visible {$IFDEF CMNLIB}default False{$ENDIF};
    property Width;
    property Height;
    {$ENDIF}
    property OnCanSaveProperty: TTMSFNCCustomComponentCanSavePropertyEvent read FOnCanSaveProperty write FOnCanSaveProperty;
    property OnCanLoadProperty: TTMSFNCCustomComponentCanLoadPropertyEvent read FOnCanLoadProperty write FOnCanLoadProperty;
  end;

  TTMSFNCCustomComponentClass = class of TTMSFNCCustomComponent;

implementation

uses
  WEBLib.TMSFNCUtils, SysUtils
  {$IFNDEF RTLONLY}
  ,WEBLib.Forms, WEBLib.TMSFNCStyles, WEBLib.TMSFNCGraphics, WEBLib.Graphics, WEBLib.TMSFNCGraphicsTypes
  {$ELSE}
  {$IFDEF FREEWARE}
  {$IFDEF FMXLIB}
  ,WEBLib.Forms, WEBLib.Controls, WEBLib.Graphics
  {$ENDIF}
  {$IFDEF VCLLIB}
  ,VCL.Forms, VCL.Graphics, VCL.Controls
  {$ENDIF}
  {$ENDIF}
  {$ENDIF}
  {$IFNDEF LCLLIB}
  ,Types
  {$ENDIF}
  {$IFDEF VCLLIB}
  ,PngImage
  {$ENDIF}
  {$IFDEF WEBLIB}
  ,WEBLib.DesignIntf
  {$ENDIF}
  {$IFDEF USETRIAL}
  {$IFNDEF LCLLIB}
  {$IFNDEF WEBLIB}
  {$IFNDEF FMXMOBILE}
  {$IFDEF FREEWARE}
  {$IFDEF MACOS}
  ,MacApi.AppKit, MacApi.Foundation, MacApi.Helpers
  {$ENDIF}
  {$IFDEF MSWINDOWS}
  ,System.Win.Registry, ShellApi
  {$ENDIF}
  {$IFDEF FMXLIB}
  ,UITypes, FMX.Types, WEBLib.StdCtrls, FMX.Objects, UIConsts
  {$ENDIF}
  {$IFDEF VCLLIB}
  ,VCL.StdCtrls, VCL.ExtCtrls
  {$ENDIF}
  {$ENDIF}
  {$ENDIF}
  {$ENDIF}
  {$ENDIF}
  {$ENDIF}
  ;

{ TTMSFNCCustomComponent }

{$IFNDEF RTLONLY}
{$IFDEF VCLLIB}
{$HINTS OFF}
{$IF COMPILERVERSION > 30}
procedure TTMSFNCCustomComponent.ChangeScale(M, D: Integer; isDpiChange: Boolean);
{$ELSE}
procedure TTMSFNCCustomComponent.ChangeScale(M, D: Integer);
{$IFEND}
begin
  inherited;
  ChangeDPIScale(M, D);
end;
{$HINTS ON}
{$ENDIF}
{$ENDIF}

procedure TTMSFNCCustomComponent.ChangeDPIScale({%H-}M, {%H-}D: Integer);
begin
end;

{$IFDEF WEBLIB}
class function TTMSFNCCustomComponent.GetVersionNumber(AMaj, AMin, ARel, ABld: ShortInt): string;
begin
  Result := '';
end;
{$ENDIF}

function TTMSFNCCustomComponent.IsAppearanceProperty(AObject: TObject; APropertyName: string; APropertyType: TTypeKind): Boolean;
begin
  Result := False;
end;

function TTMSFNCCustomComponent.CanSaveProperty(AObject: TObject; APropertyName: string; APropertyType: TTypeKind): Boolean;
begin
  if (AObject = Self) and not BlockPersistenceInterface then
    Result := (TTMSFNCUtils.IndexOfTextInArray(APropertyName, ExcludePropertyList) = -1)
  else
    Result := True;

  if FAppearancePersisting then
    Result := Result and IsAppearanceProperty(AObject, APropertyName, APropertyType);

  DoCanSaveProperty(AObject, APropertyName, APropertyType, Result);
end;

function TTMSFNCCustomComponent.CanLoadProperty(AObject: TObject; APropertyName: string; APropertyType: TTypeKind): Boolean;
begin
  if (AObject = Self) and not BlockPersistenceInterface then
    Result := (TTMSFNCUtils.IndexOfTextInArray(APropertyName, ExcludePropertyList) = -1)
  else
    Result := True;

  DoCanLoadProperty(AObject, APropertyName, APropertyType, Result);
end;

constructor TTMSFNCCustomComponent.Create(AOwner: TComponent);
var
  ppi: Integer;
{$IFNDEF RTLONLY}
{$IFDEF VCLLIB}
{$HINTS OFF}
{$IF COMPILERVERSION > 34}
  f: TCustomForm;
{$IFEND}
{$HINTS ON}
{$ENDIF}
{$ENDIF}
begin
  inherited;
  ppi := 96;
  {$IFNDEF RTLONLY}
  {$IFDEF VCLLIB}
  {$HINTS OFF}
  {$IF COMPILERVERSION > 34}
  f := TTMSFNCUtils.GetOwnerForm(Self);
  if Assigned(f) then
    ppi := f.PixelsPerInch;
  {$IFEND}
  {$HINTS ON}
  {$ENDIF}
  {$ENDIF}

  FDesigntimeFormPixelsPerInch := ppi;

  {$IFNDEF RTLONLY}
  SetDefaultGraphicColors;
  Width := 26;
  Height := 26;
  {$ENDIF}

  if not IsDesigning then
    RegisterRuntimeClasses;
end;

procedure TTMSFNCCustomComponent.DoCanLoadProperty(AObject: TObject;
  APropertyName: string; APropertyType: TTypeKind; var ACanLoad: Boolean);
begin
  if Assigned(OnCanLoadProperty) then
    OnCanLoadProperty(Self, AObject, APropertyName, APropertyType, ACanLoad);
end;

procedure TTMSFNCCustomComponent.DoCanSaveProperty(AObject: TObject;
  APropertyName: string; APropertyType: TTypeKind; var ACanSave: Boolean);
begin
  if Assigned(OnCanSaveProperty) then
    OnCanSaveProperty(Self, AObject, APropertyName, APropertyType, ACanSave);
end;

function TTMSFNCCustomComponent.GetDocURL: string;
begin
  Result := TTMSFNCBaseDocURL;
end;

{$IFNDEF RTLONLY}
procedure TTMSFNCCustomComponent.SetDefaultGraphicColors;
var
  c: TTMSFNCGraphicsColor;
begin
  c := gcNull;
  if TTMSFNCStyles.GetStyleBackgroundFillColor(c) then
    TTMSFNCGraphics.DefaultPopupFillColor := c
  else
    TTMSFNCGraphics.DefaultPopupFillColor := gcWhite;

  c := gcNull;
  if TTMSFNCStyles.GetStyleBackgroundStrokeColor(c) then
    TTMSFNCGraphics.DefaultPopupStrokeColor := c
  else
    TTMSFNCGraphics.DefaultPopupStrokeColor := gcSilver;

  c := gcNull;
  if TTMSFNCStyles.GetStyleDefaultButtonFillColor(c) then
    TTMSFNCGraphics.DefaultButtonFillColor := c
  else
    TTMSFNCGraphics.DefaultButtonFillColor := MakeGraphicsColor(225, 225, 225);

  c := gcNull;
  if TTMSFNCStyles.GetStyleLineFillColor(c) then
    TTMSFNCGraphics.DefaultButtonStrokeColor := c
  else
    TTMSFNCGraphics.DefaultButtonStrokeColor := gcDarkgray;

  c := gcNull;
  if TTMSFNCStyles.GetStyleTextFontColor(c) then
    TTMSFNCGraphics.DefaultTextFontColor := c
  else
    TTMSFNCGraphics.DefaultTextFontColor := gcBlack;

  c := gcNull;
  if TTMSFNCStyles.GetStyleSelectionFillColor(c) then
  begin
    TTMSFNCGraphics.DefaultSelectionFillColor := c;
    TTMSFNCGraphics.DefaultButtonFillColorFocused := Blend(c, TTMSFNCGraphics.DefaultButtonFillColor, 25);
    TTMSFNCGraphics.DefaultButtonStrokeColorFocused := Blend(c, TTMSFNCGraphics.DefaultButtonStrokeColor, 30);
  end
  else
  begin
    TTMSFNCGraphics.DefaultSelectionFillColor := gcBlack;
    TTMSFNCGraphics.DefaultButtonFillColorFocused := MakeGraphicsColor(229, 241, 251);
    TTMSFNCGraphics.DefaultButtonStrokeColorFocused := MakeGraphicsColor(60, 127, 177);
  end;

  TTMSFNCGraphics.DefaultButtonStrokeColorDisabled := gcDarkGray;
  TTMSFNCGraphics.DefaultButtonFillColorDisabled := gcLightgray;
end;
{$ENDIF}

function TTMSFNCCustomComponent.GetInstance: NativeUInt;
begin
  Result := HInstance;
end;

function TTMSFNCCustomComponent.GetTipsURL: string;
begin
  Result := TTMSFNCBaseTipsURL;
end;

function TTMSFNCCustomComponent.GetVersion: string;
begin
  Result := '';
end;

function TTMSFNCCustomComponent.IsDesignTime: Boolean;
begin
  Result := False;
  if Assigned(Owner) then
    Result := IsDesigning and not ((csReading in Owner.ComponentState) or (csLoading in Owner.ComponentState));
end;

function TTMSFNCCustomComponent.IsReading: Boolean;
begin
  Result := (csReading in Owner.ComponentState);
end;

function TTMSFNCCustomComponent.IsDesigning: Boolean;
begin
  {$IFDEF RTLONLY}
  Result := ((csDesigning in ComponentState));
  {$ELSE}
  Result := ((csDesigning in ComponentState) {$IFDEF WEBLIB}or Assigned(VSIDE){$ENDIF});
  {$ENDIF}
end;

function TTMSFNCCustomComponent.IsDestroying: Boolean;
begin
  Result := (csDestroying in ComponentState);
end;

function TTMSFNCCustomComponent.IsLoading: Boolean;
begin
  Result := (csLoading in Owner.ComponentState);
end;

procedure TTMSFNCCustomComponent.Loaded;
begin
  inherited;
  RealignLabel;

  {$IFNDEF RTLONLY}
  if not (csDesigning in ComponentState) then
    Visible := False;
  {$ENDIF}
end;

procedure TTMSFNCCustomComponent.SaveSettingsToFile(AFileName: string; AAppearanceOnly: Boolean = False);
begin
  FAppearancePersisting := AAppearanceOnly;
  TTMSFNCPersistence.SaveSettingsToFile(Self, AFileName);
  FAppearancePersisting := False;
end;

procedure TTMSFNCCustomComponent.LoadSettingsFromFile(AFileName: string);
begin
  TTMSFNCPersistence.LoadSettingsFromFile(Self, AFileName);
end;

procedure TTMSFNCCustomComponent.SaveSettingsToStream(AStream: TStream; AAppearanceOnly: Boolean = False);
begin
  FAppearancePersisting := AAppearanceOnly;
  TTMSFNCPersistence.SaveSettingsToStream(Self, AStream);
  FAppearancePersisting := False;
end;

procedure TTMSFNCCustomComponent.LoadSettingsFromStream(AStream: TStream);
begin
  TTMSFNCPersistence.LoadSettingsFromStream(Self, AStream);
end;

procedure TTMSFNCCustomComponent.Notification(AComponent: TComponent;
  AOperation: TOperation);
begin
  inherited;

  {$IFNDEF RTLONLY}
  if (AComponent = FNameLabel) and (AOperation = opRemove) then
    FNameLabel := nil;
  {$ENDIF}
end;

{$IFDEF FMXLIB}
{$HINTS OFF}
{$IF COMPILERVERSION = 28}
procedure TTMSFNCCustomComponent.BeginUpdate;
begin
end;

procedure TTMSFNCCustomComponent.EndUpdate;
begin
end;
{$IFEND}
{$HINTS ON}
{$ENDIF}

{$IFDEF CMNWEBLIB}
procedure TTMSFNCCustomComponent.BeginUpdate;
begin
  {$IFDEF WEBLIB}
  inherited;
  {$ENDIF}
end;

procedure TTMSFNCCustomComponent.EndUpdate;
begin
  {$IFDEF WEBLIB}
  inherited;
  {$ENDIF}
end;
{$ENDIF}

{$IFNDEF RTLONLY}
procedure TTMSFNCCustomComponent.Paint;
var
  {$IFDEF VCLLIB}
  png: TPngImage;
  {$ENDIF}
  pic: TTMSFNCBitmap;
  g: TTMSFNCGraphics;
  r: TResourceStream;
  {$IFDEF WEBLIB}
  rc: TRegisteredComponent;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  c: TClass;
  {$ENDIF}
begin
  inherited;
  r := nil;
  pic := TTMSFNCBitmap.Create;
  {$IFDEF VCLLIB}
  png := TPNGImage.Create;
  {$ENDIF}
  g := TTMSFNCGraphics.Create(Canvas);
  try
    g.Stroke.Kind := gskSolid;
    g.Stroke.Color := gcBlack;
    g.DrawRectangle(RectF(0, 0, Width, Height));

    {$IFNDEF WEBLIB}
    r := TTMSFNCUtils.GetResourceStream(UpperCase(ClassName), GetInstance);
    c := ClassParent;
    while Assigned(c) and not Assigned(r) do
    begin
      r := TTMSFNCUtils.GetResourceStream(UpperCase(c.ClassName), GetInstance);
      c := c.ClassParent;
    end;

    if Assigned(r) then
    begin
      {$IFDEF VCLLIB}
      png.LoadFromStream(r);
      pic.Assign(png);
      {$ELSE}
      pic.LoadFromStream(r);
      {$ENDIF}
    end;
    {$ENDIF}

    {$IFDEF WEBLIB}
    rc := GetRegisteredComponent(ClassName);
    if Assigned(rc) then
      pic.LoadFromResource(rc.Icon);
    {$ENDIF}

    g.DrawBitmap(RectF(2, 2, Width - 2, Height - 2), pic, True, True);
  finally
    if Assigned(r) then
      r.Free;

    pic.Free;
    {$IFDEF VCLLIB}
    png.Free;
    {$ENDIF}
    g.Free;
  end;
end;
{$ENDIF}

procedure TTMSFNCCustomComponent.RealignLabel;
begin
  {$IFNDEF RTLONLY}
  if Assigned(FNameLabel) then
    FNameLabel.SetBounds(Left, Top, Width, Height);
  {$ENDIF}
end;

procedure TTMSFNCCustomComponent.RegisterRuntimeClasses;
begin
end;

procedure TTMSFNCCustomComponent.SetAdaptToStyle(const Value: Boolean);
begin
  FAdaptToStyle := Value;
end;

procedure TTMSFNCCustomComponent.SetName(const Value: TComponentName);
begin
  inherited;
  {$IFNDEF RTLONLY}
  if not Assigned(FNameLabel) and (csDesigning in ComponentState) and (Owner is TCustomForm) then
  begin
    FNameLabel := TTMSFNCNameLabel.Create(Self);
    {$IFDEF VCLLIB}
    if Owner is TWinControl then
      FNameLabel.Parent := Owner as TWinControl;
    {$ELSE}
    FNameLabel.Parent := Self;
    {$ENDIF}

    FNameLabel.TabStop := False;
    {$IFDEF FMXLIB}
    FNameLabel.HitTest := False;
    FNameLabel.Stored := False;
    {$ENDIF}
  end;

  RealignLabel;
  {$ENDIF}
end;

{$IFNDEF RTLONLY}
{$IFDEF FMXLIB}
procedure TTMSFNCCustomComponent.SetBounds(X, Y, AWidth, AHeight: Single);
{$ENDIF}
{$IFDEF CMNWEBLIB}
procedure TTMSFNCCustomComponent.SetBounds(X, Y, AWidth, AHeight: Integer);
{$ENDIF}
var
  sc: Single;
begin
  sc := FDesigntimeFormPixelsPerInch / 96;
  inherited SetBounds(X, Y, Round(26 * sc), Round(26 * sc));

  RealignLabel;
end;

{ TTMSFNCNameLabel }

{$IFDEF FMXLIB}
procedure TTMSFNCNameLabel.SetBounds(X, Y, AWidth, AHeight: Single);
{$ENDIF}
{$IFDEF CMNWEBLIB}
procedure TTMSFNCNameLabel.SetBounds(X, Y, AWidth, AHeight: Integer);
{$ENDIF}
var
  l, t, w, h: Single;
  sc: Integer;
  sz: TSizeF;
  g: TTMSFNCGraphics;
  c: TControl;
  {$IFDEF VCLLIB}
  pt: TPoint;

  function GetOwnerTopLeft: TPoint;
  var
    p: TControl;
  begin
    Result := Point(c.Left, c.Top);
    p := c.Parent;
    while Assigned(p) and (p <> Parent) do
    begin
      Result.X := Result.X + p.Left;
      Result.Y := Result.Y + p.Top;
      p := p.Parent;
    end;
  end;
  {$ENDIF}
begin
  g := TTMSFNCGraphics.CreateBitmapCanvas();
  try
    sc := 6;
    if Assigned(Owner) and (Owner is TTMSFNCCustomComponent) then
    begin
      g.Font.Height := TTMSFNCUtils.MulDivInt(g.Font.Height, (Owner as TTMSFNCCustomComponent).FDesigntimeFormPixelsPerInch, 96);
      sc := TTMSFNCUtils.MulDivInt(sc, (Owner as TTMSFNCCustomComponent).FDesigntimeFormPixelsPerInch, 96);
    end;

    sz := g.CalculateTextSize(Text);
    w := sz.cx + sc;
    h := sz.cy + sc;
  finally
    g.Free;
  end;

  if Assigned(Owner) and (Owner is TControl) then
  begin
    c := (Owner as TControl);
    {$IFDEF VCLLIB}
    pt := GetOwnerTopLeft;
    l := pt.X + c.Width / 2 - w / 2;
    t := pt.Y + c.Height;
    {$ELSE}
    l := c.Width / 2 - w / 2;
    t := c.Height;
    {$ENDIF}
  end
  else
  begin
    l := X;
    t := Y;
  end;

  inherited SetBounds(Round(l), Round(t), Round(w), Round(h));
end;

function TTMSFNCNameLabel.GetText: string;
begin
  Result := '';
  if Assigned(Owner) then
    Result := Owner.Name;
end;

procedure TTMSFNCNameLabel.Paint;
var
  g: TTMSFNCGraphics;
begin
  inherited;
  g := TTMSFNCGraphics.Create(Canvas);
  try
    g.Stroke.Kind := gskSolid;
    g.Stroke.Color := gcBlack;
    g.Fill.Kind := gfkSolid;
    g.Fill.Color := gcWhite;

    g.DrawRectangle(RectF(0, 0, Width, Height));

    if Assigned(Owner) and (Owner is TTMSFNCCustomComponent) then
      g.Font.Height := TTMSFNCUtils.MulDivInt(g.Font.Height, (Owner as TTMSFNCCustomComponent).FDesigntimeFormPixelsPerInch, 96);

    g.DrawText(RectF(0, 0, Width, Height), Text, False, gtaCenter, gtaCenter);

  finally
    g.Free;
  end;
end;
{$ENDIF}

{$IFDEF USETRIAL}
{$IFNDEF WEBLIB}
{$IFNDEF LCLLIB}
{$IFNDEF FMXMOBILE}
{$IFDEF FREEWARE}
const TMSPRODUCTOFFSET = 700;
{$I TMSProductTrial.inc}
{$ENDIF}
{$ENDIF}
{$ENDIF}
{$ENDIF}
{$ENDIF}

end.
